import { type FC, type ReactNode } from "react";

interface ItemBlockProps {
  mainTitle?: ReactNode;
  secondTitle?: ReactNode;
  mainValue?: ReactNode;
  secondValue?: ReactNode;
  className?: string;
}
const ItemBlock: FC<ItemBlockProps> = ({ mainTitle, secondTitle, mainValue, secondValue, className = "" }) => {
  const validValue: Function = (value: any): boolean => value !== null && value !== undefined;

  return (
    <div className={"scha__order-details-display-print__orders__item__block " + className}>
      {validValue(mainTitle) && (
        <div className="scha__order-details-display-print__orders__item__block__main-title">{mainTitle}</div>
      )}
      {validValue(secondTitle) && (
        <div className="scha__order-details-display-print__orders__item__block__second-title">{secondTitle}</div>
      )}
      {validValue(mainValue) && (
        <div className="scha__order-details-display-print__orders__item__block__main-value">{mainValue}</div>
      )}
      {validValue(secondValue) && (
        <div className="scha__order-details-display-print__orders__item__block__second-value">{secondValue}</div>
      )}
    </div>
  );
};

export default ItemBlock;
